import { Injectable } from '@angular/core';
import { ToolTipSettings } from './domain/shared/component/tooltip/tooltip.util';

@Injectable({
  providedIn: 'root',
})
export class ToolTipService {

  activateToolTip(id: string, text: string, maxLen: number, toolTipSettings: ToolTipSettings): ToolTipSettings {
    if (!text || text === '\n' || text.length <= maxLen) {
      return;
    }

    toolTipSettings = {
      show: true,
      coordinates: document.getElementById(id).getBoundingClientRect(),
      title: text,
    };
    return { ...toolTipSettings };
  }
}
